import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.less';

const Section = ({ children, childClassName = '', className = '', header }) => {
  return (
    <div key={childClassName} className={`${style.group} ${style[className] ?? ''}`}>
      <div className={style['group-header']}>{header}</div>
      <div className={style[childClassName]}>{children}</div>
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  childClassName: PropTypes.string,
  className: PropTypes.string,
  header: PropTypes.node.isRequired,
};

export default Section;
